import React,{useEffect,useState} from "react";
import CustomHeading from "../../../constants/CustomHeading";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "../../../constants/CustomInput";
import CustomButton from "../../../constants/CustomButton";
import CustomRichTextField from "../../../constants/CustomRichTextField";
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {getbookchapterData,setbookchapterData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";

const validationSchema = Yup.object().shape({
  book_title: Yup.string().required("Required"),
  chapter_title: Yup.string().required("Required"),
});
const BookChapter = (props) => {
  const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getbookchapterData();
    },[isLoading])
    const columns = [ 
        {title:'Book title',field:'book_title'},
        {title:'Chapter Title',field:'chapter_title' },
        {title:'Author',field:'author'},
        {title:'Editor',field:'editor'},
        {title:'ISBN',field:'isbn'},

      ]
  return (
    <div className="customContainer">
      <CustomHeading title="Book Chapter" />
      <CustomTableWithAll data={props?.book_chapter?.data}  columns={columns} api="/api/book-chapter/"  title={'All Book Chapters'} />
        <CustomLine/>
      <Formik
        initialValues={{
          book_title: "",
          chapter_title: "",
          author: "",
          editor: "",
          isbn: "",
          description: "",
          created_by: "admin@test.com",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log(values);
          props.setbookchapterData(values);
          setIsLoading(true)
        }}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit} style={{ marginTop: 0 }}>
            <div className="row">
              <div className="col-md-6">
                <CustomInput
                  type={"text"}
                  placeholder={"Enter Book Title"}
                  label={"Book Title :"}
                  onChange={handleChange("book_title")}
                  errorText={
                    errors.book_title && touched.book_title
                      ? errors.book_title
                      : null
                  }
                />
              </div>
              <div className="col-md-6">
                <CustomInput
                  type={"text"}
                  placeholder={"Enter Editor Details"}
                  label={"Editor :"}
                  onChange={handleChange("editor")}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <CustomInput
                  type={"text"}
                  placeholder={"Enter Chapter Title"}
                  label={"Chapter Title :"}
                  onChange={handleChange("chapter_title")}
                  errorText={
                    errors.chapter_title && touched.chapter_title
                      ? errors.chapter_title
                      : null
                  }
                />
              </div>
              <div className="col-md-6">
                <CustomInput
                  type={"text"}
                  placeholder={"International Standard Book Number"}
                  label={"ISBN :"}
                  onChange={handleChange("isbn")}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <CustomRichTextField
                  label={"Description"}
                  onChange={handleChange("description")}
                />
              </div>
              <div className="col-md-6">
                <CustomInput
                  type={"text"}
                  placeholder={"Enter Author(s)"}
                  label={"Author(s) :"}
                  onChange={handleChange("author")}
                />
              </div>
            </div>
            <CustomButton type="submit" label="Save" />
          </Form>
        )}
      </Formik>
    </div>
  );
};

const mapActionWithProps = {
  getbookchapterData,
  setbookchapterData,
}

const mapStateWithProps = (state)=>(
  {
    book_chapter:state.data.book_chapter
  }
)
export default connect(mapStateWithProps,mapActionWithProps) (BookChapter);
